//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignInDialog from '@/components/ui/landing/signin/SignInDialog.vue';
import AlertDialog from '@/components/ui/landing/dialog/AlertDialog.vue';
import AppHeader from '@/components/ui/landing/header/AppHeader.vue';
import FabButton from '@/components/util/FabButton';
import DefaultFooter from '@/components/ui/landing/footer/DefaultFooter.vue';
import CartModifyDialog from '@/components/ui/landing/dialog/CartModifyDialog.vue';
import ProductDetailDialog from '@/components/ui/landing/dialog/ProductDetailDialog.vue';

export default {
	components: {
		AppHeader,
		FabButton,
		AlertDialog,
		DefaultFooter,
		SignInDialog,
		ProductDetailDialog,
		CartModifyDialog,
	},
	async mounted() {
		// 도매상 정보 가져오기
		const mallId = process.env.partnerMallId;
		await this.$store.dispatch('mall/getPartnerMallById', mallId);
		await this.fetchShops();
	},
	methods: {
		async fetchShops() {
			try {
				await this.$store.dispatch('auth/getCustomerShop', '');
				// this.setFormData();
			} catch (error) {}
		},
	},
};
